import { TranslationConfig } from '@coolblue-development/next-translations';

import dictionary from './dictionary.json';

const config: TranslationConfig = {
  resource: 'careers-website-microfrontend',
  dictionary
};

export default config;
